// extracted by mini-css-extract-plugin
export var buttonContainer = "_8a-1";
export var fontSizeSelect = "_8a-3";
export var formatSelect = "_8a-2";
export var formats = "_8a-4";
export var hidden = "_8a-5";
export var icon = "_8a-6";
export var select = "_8a-0";